import { render, staticRenderFns } from "./filesModal.vue?vue&type=template&id=125cdfb7&"
import script from "./filesModal.vue?vue&type=script&lang=js&"
export * from "./filesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports